import { render, staticRenderFns } from "./FormSystemNotice.vue?vue&type=template&id=0d144512"
import script from "./FormSystemNotice.vue?vue&type=script&lang=js"
export * from "./FormSystemNotice.vue?vue&type=script&lang=js"
import style0 from "./FormSystemNotice.vue?vue&type=style&index=0&id=0d144512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports